// src/pages/reservas/components/MapaReservas.jsx
import React from 'react';

export default function MapaReservas({
  zonas,
  mapScale,
  baseWidth,
  baseHeight,
  offsetX,
  offsetY,
  esLounge,
  numeroVisible,
  colorPorEstado,
  onZonaClick,
  disabled = false,
  disabledTitle = '',
  seleccionadaId,
  etiquetaZona,
  modoSeleccion = false,
}) {
  return (
    <div className="mapa-reservas-wrapper">
      <div
        className="mapa-reservas"
        style={{
          width: baseWidth * mapScale,
          height: baseHeight * mapScale,
        }}
      >
        {(zonas || []).map((zona) => (
          <button
            key={zona.id}
            type="button"
            aria-label={etiquetaZona ? etiquetaZona(zona) : undefined}
            aria-pressed={modoSeleccion ? seleccionadaId === zona.id : undefined}
            className={`zona-boton ${esLounge(zona) ? 'zona-boton--lounge' : 'zona-boton--mesa'} ${modoSeleccion && seleccionadaId === zona.id ? 'zona-boton--seleccionada' : ''}`}
            style={{
              left: (zona.x + offsetX) * mapScale,
              top: (zona.y + offsetY) * mapScale,
              width: zona.width * mapScale,
              height: zona.height * mapScale,
              '--estado-color': colorPorEstado(zona.estado),
            }}
            onClick={() => onZonaClick(zona)}
            disabled={disabled || zona.bloqueada}
            title={disabled ? disabledTitle : zona.bloqueada ? 'Zona ocupada por otro usuario' : ''}
          >
            <span className="zona-numero">{numeroVisible(zona)}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
